import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { ActivityMenuItem } from "../enum"
import { Status } from "../../../../../../../../utils/enums"
import { Item } from "../../../../../../../../utils/types/generals"


export const useMenu = ({ status, canDelete, locationOn, geofence, isTheUserAssigned, canFinish, canStart }: { status: Status; canStart:boolean, canFinish:boolean, canDelete: boolean; geofence?: boolean; locationOn: boolean, isTheUserAssigned?: boolean }) => {
    const { t } = useTranslation()
    const [menuByStatus, setMenuByStatus] = useState<Item[]>([])
    const deleteItem = { label: t('general.delete'), value: ActivityMenuItem.DELETE }
    const editItem = { label: t('general.edit'), value: ActivityMenuItem.EDIT }
    const seeReportItem = { label: t('general.seeReport'), value: ActivityMenuItem.SEE_REPORT }
    const startActivityItem = { label: t('loogbook.startActivity'), value: ActivityMenuItem.START }
    const cancelActivityItem = { label: t('general.cancelActivity'), value: ActivityMenuItem.CANCEL }
    const finishtItem = { label: t('loogbook.finishActivity'), value: ActivityMenuItem.FINISH }
    const forcedItem = { label: t('general.forceClosure'), value: ActivityMenuItem.FORCEDFINISH }
    const resendItem = { label: t('general.resendReport'), value: ActivityMenuItem.RESEND_INFORM }
    const reScheduleItem = { label: t('general.reSchedule'), value: ActivityMenuItem.RESCHEDULE }
    const optionMenu = {
        [Status.FINISHED]: [seeReportItem, resendItem],
        [Status.NOT_FINISHED]: [seeReportItem, resendItem],
        [Status.EXPIRED]: [seeReportItem, resendItem],
        [Status.CANCEL]: [seeReportItem, deleteItem],
        [Status.TO_BE_STARTED]: [startActivityItem, cancelActivityItem, editItem, reScheduleItem, seeReportItem, deleteItem],
        [Status.STARTED]: [finishtItem, forcedItem, cancelActivityItem, reScheduleItem, seeReportItem, deleteItem],
    } as Record<Status, Item[]>


    useEffect(() => {
        setMenuByStatus(optionMenu[status]?.filter(menu => {
            if ([ActivityMenuItem.DELETE, ActivityMenuItem.CANCEL].includes(menu.value) && !canDelete) { return false }
            if ([ActivityMenuItem.FORCEDFINISH].includes(menu.value) && ((!locationOn) || (!isTheUserAssigned))) { return false }
            if ([ActivityMenuItem.RESCHEDULE].includes(menu.value) && ((geofence) || (!canDelete))) { return false }
            if ([ActivityMenuItem.START].includes(menu.value) && ( (!canStart))) { return false }
            if ([ActivityMenuItem.FINISH].includes(menu.value) && ( (!canFinish))) { return false }
            return true
        }))
    }, [canDelete, status, locationOn, geofence])
    return { menu: menuByStatus }
}